/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/12
 * Time: 10:08
 */
<template>
  <div id='page1' class="page1">
    <div class="logos-group">
      <a class="kt"></a>
      <a class="alibaba"></a>
      <a class="tianxi"></a>
      <a class="bbg"></a>
    </div>
    <div class="slogan"></div>
    <a class="video" @click="showVideoFrame"></a>
    <div class="logo"></div>
    <div class="store-group">
      <a href="http://itunes.apple.com/KR/app/id1353267865?mt=8" class="app-store"></a>
      <a href="https://play.google.com/store/apps/details?id=com.aligames.sgzhg.google" class="google-play"></a>
    </div>
    <div class="download-button" @touchstart.stop="toggleDownload('enter')"></div>
    <div class="download-group-mb" :class="{'download-group-mb-visible': downloadVisible}" @touchstart.stop="toggleDownload('leave')">
      <div class="download-inside-group">
        <a class="GooglePlay" href="https://play.google.com/store/apps/details?id=com.aligames.sgzhg.google"></a>
        <a class="AppStore" href="http://itunes.apple.com/KR/app/id1353267865?mt=8"></a>
        <a class="OneStore" href="http://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000726276"></a>
        <a class="GalaxyApps" href="http://apps.samsung.com/appquery/appDetail.as?appId=com.aligames.sgzhg.samsung"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'page1',
  data () {
    return {
      downloadVisible: false
    }
  },
  components: {

  },
  methods: {
    ...mapMutations({
      alert: 'clickBtn'
    }),
    notReady () {
      this.alert(['기대해주세요'])
    },
    toggleDownload (type) {
      console.log('found', type)
      switch (type) {
        case 'enter':
          this.downloadVisible = true
          break
        case 'leave':
          setTimeout(() => {
            this.downloadVisible = false
          }, 1000)
          break
      }
    },
    showVideoFrame () {
      this.$emit('onVideoVisible')
    }
  },
  mounted: function () {
    // page1 mounted
    this.$lib.addC4M('page1', 'page1-mb')
    this.$lib.addC4Mac('page1', 'page1-Mac')
    this.$lib.addC4iPad('page1', 'page1-iPad')
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.page1 {
  //begin you code
  background: url("../assets/images/index/bg/header.jpg") center top no-repeat;
  .logos-group {
    position: absolute;
    top: 70px;
    right: 50px;
    height: 60px;
    a {
      width: 40px;
      height: 40px;
      display: inline-block;
      margin-right: 10px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .alibaba {
      background: url("../assets/images/basicIcon/logo-alibaba.png") center top no-repeat;
      background-size: contain;
    }
    .bbg {
      background: url("../assets/images/basicIcon/logo-bbg.png") center top no-repeat;
      background-size: contain;
    }
    .kt {
      width: 60px;
      background: url("../assets/images/basicIcon/logo-kt.png") center top no-repeat;
      background-size: contain;
    }
    .tianxi {
      background: url("../assets/images/basicIcon/logo-tianxi.png") center top no-repeat;
      background-size: contain;
    }
  }
  .video {
    display: block;
    cursor: pointer;
    width: 120px;
    height: 120px;
    background: url("../assets/images/index/page1/play-btn.png") center top no-repeat;
    background-size: contain;
    position: relative;
    top: 420px;
    left: 50%;
    transform: translateX(-50%);
  }
  .slogan {
    position: absolute;
    top: 420px;
    left: 50%;
    transform: translateX(-50%);
    width: 1100px;
    height: 300px;
    background: url("../assets/images/index/page1/header-slogan.png") center top no-repeat;
    background-size: contain;
  }
  .logo {
    width: 600px;
    height: 350px;
    background: url("../assets/images/index/page1/logo.png") center top no-repeat;
    background-size: contain;
    position: absolute;
    top: 590px;
    left: 50%;
    transform: translateX(-50%);
  }
  .store-group {
    display: none;
    position: absolute;
    top: 850px;
    left: 50%;
    transform: translateX(-50%);
    a {
      float: left;
      display: inline-block;
      width: 165px;
      height: 53px;
    }
    .app-store {
      background: url("../assets/images/index/page1/app-store.png") center top no-repeat;
      background-size: contain;
      margin-right: 30px;
    }
    .google-play {
      background: url("../assets/images/index/page1/google-play.png") center top no-repeat;
      background-size: contain;
    }
  }
  .download-button {
    display: none;
  }
  .download-group-mb {
    display: none;
  }
}
.page1-Mac {
  //begin you code
  background: url("../assets/images/index/bg/header.jpg") center top no-repeat;
  .logos-group {
    position: absolute;
    top: 70px;
    right: 50px;
    height: 60px;
    a {
      width: 40px;
      height: 40px;
      display: inline-block;
      margin-right: 10px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .alibaba {
      background: url("../assets/images/basicIcon/logo-alibaba.png") center top no-repeat;
      background-size: contain;
    }
    .bbg {
      background: url("../assets/images/basicIcon/logo-bbg.png") center top no-repeat;
      background-size: contain;
    }
    .kt {
      width: 60px;
      background: url("../assets/images/basicIcon/logo-kt.png") center top no-repeat;
      background-size: contain;
    }
    .tianxi {
      background: url("../assets/images/basicIcon/logo-tianxi.png") center top no-repeat;
      background-size: contain;
    }
  }
  .video {
    display: block;
    cursor: pointer;
    width: 120px;
    height: 120px;
    background: url("../assets/images/index/page1/play-btn.png") center top no-repeat;
    background-size: contain;
    position: relative;
    top: 360px;
    left: 50%;
    transform: translateX(-50%) scale(.7);
  }
  .slogan {
    top: 365px;
  }
  .logo {
    width: 600px;
    height: 350px;
    background: url("../assets/images/index/page1/logo.png") center top no-repeat;
    background-size: contain;
    position: absolute;
    top: 490px;
    left: 50%;
    transform: translateX(-50%) scale(.8);
  }
  .store-group {
    position: absolute;
    top: 580px;
    left: 50%;
    transform: translateX(-50%) scale(.7);
    a {
      float: left;
      display: inline-block;
      width: 165px;
      height: 53px;
    }
    .app-store {
      background: url("../assets/images/index/page1/app-store.png") center top no-repeat;
      background-size: contain;
      margin-right: 30px;
    }
    .google-play {
      background: url("../assets/images/index/page1/google-play.png") center top no-repeat;
      background-size: contain;
    }
  }
}
.page1-mb {
  //begin you code
  background: url("../assets/images/index-mb/bg/header.jpg") center top no-repeat;
  background-size: 100% auto!important;
  .logos-group {
    position: absolute;
    top: 1.2rem;
    right: 0.1rem;
    height: .60rem;
    a {
      width: .60rem;
      height: .60rem;
      display: inline-block;
    }
    .alibaba {
      display: none;
      background: url("../assets/images/basicIcon/logo-alibaba.png") center top no-repeat;
      background-size: contain;
    }
    .bbg {
      background: url("../assets/images/basicIcon/logo-bbg.png") center top no-repeat;
      background-size: contain;
    }
    .kt {
      width: .90rem;
      background: url("../assets/images/basicIcon/logo-kt.png") center top no-repeat;
      background-size: contain;
    }
    .tianxi {
      display: none;
      background: url("../assets/images/basicIcon/logo-tianxi.png") center top no-repeat;
      background-size: contain;
    }
  }
  .video {
    display: block;
    width: 1.75rem;
    height: 1.75rem;
    background: url("../assets/images/index-mb/page1/play-btn.png") center top no-repeat;
    background-size: contain;
    position: relative;
    top: 4.05rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .slogan {
    position: absolute;
    top: 4.70rem;
    left: 50%;
    transform: translateX(-50%);
    width: 7.68rem;
    height: 3.00rem;
    background: url("../assets/images/index-mb/page1/header-slogan.png") center top no-repeat;
    background-size: contain;
  }
  .logo {
    width: 6.06rem;
    height: 3.00rem;
    background: url("../assets/images/index-mb/page1/logo.png") center top no-repeat;
    background-size: contain;
    position: absolute;
    top: 6.65rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .store-group {
    position: absolute;
    top: 10.00rem;
    left: 50%;
    transform: translateX(-50%);
    min-width: 4.8rem;
    a {
      float: left;
      display: inline-block;
      width: 2.25rem;
      height: .71rem;
    }
    .app-store {
      background: url("../assets/images/index-mb/page1/app-store.png") center top no-repeat;
      background-size: contain;
      margin-right: .30rem;
    }
    .google-play {
      background: url("../assets/images/index-mb/page1/google-play.png") center top no-repeat;
      background-size: contain;
    }
  }
  .download-button {
    display: block;
    position: absolute;
    bottom: .20rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.00rem;
    height: .75rem;
    background: url("../assets/images/index-mb/download/download-icon.png") center top no-repeat;
    background-size: contain;
  }
  .download-group-mb {
    display: block;
    position: absolute;
    bottom: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all .8s;
    padding: .50rem 0;
    .download-inside-group {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: .50rem 0;
      background: rgba(0,0,0,.85);
      a {
        display: block;
        cursor: pointer;
        width: 3.91rem;
        height: .86rem;
        margin: 0 auto .10rem;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .GooglePlay {
        background: url("../assets/images/index-mb/download/download-icon01.png") center top no-repeat;
        background-size: contain;
      }
      .AppStore {
        background: url("../assets/images/index-mb/download/download-icon02.png") center top no-repeat;
        background-size: contain;
      }
      .OneStore {
        background: url("../assets/images/index-mb/download/download-icon03.png") center top no-repeat;
        background-size: contain;
      }
      .GalaxyApps {
        background: url("../assets/images/index-mb/download/download-icon04.png") center top no-repeat;
        background-size: contain;
      }
    }
  }
  .download-group-mb-visible {
    opacity: 1;
    bottom: 0;
  }
}
.page1-iPad {
  //begin you code
  background: url("../assets/images/index-mb/bg/header.jpg") center top no-repeat;
  background-size: 100% auto!important;
  .logos-group {
    position: absolute;
    top: 1.2rem;
    right: 0.1rem;
    height: .60rem;
    a {
      width: .60rem;
      height: .60rem;
      display: inline-block;
    }
    .alibaba {
      display: none;
      background: url("../assets/images/basicIcon/logo-alibaba.png") center top no-repeat;
      background-size: contain;
    }
    .bbg {
      background: url("../assets/images/basicIcon/logo-bbg.png") center top no-repeat;
      background-size: contain;
    }
    .kt {
      width: .90rem;
      background: url("../assets/images/basicIcon/logo-kt.png") center top no-repeat;
      background-size: contain;
    }
    .tianxi {
      display: none;
      background: url("../assets/images/basicIcon/logo-tianxi.png") center top no-repeat;
      background-size: contain;
    }
  }
  .video {
    display: block;
    width: 1.75rem;
    height: 1.75rem;
    background: url("../assets/images/index-mb/page1/play-btn.png") center top no-repeat;
    background-size: contain;
    position: relative;
    top: 3.75rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .slogan {
    position: absolute;
    top: 4.20rem;
    left: 50%;
    transform: translateX(-50%);
    width: 7.68rem;
    height: 3.00rem;
    background: url("../assets/images/index-mb/page1/header-slogan.png") center top no-repeat;
    background-size: contain;
  }
  .logo {
    width: 6.06rem;
    height: 3.00rem;
    background: url("../assets/images/index-mb/page1/logo.png") center top no-repeat;
    background-size: contain;
    position: absolute;
    top: 5.45rem;
    left: 50%;
    transform: translateX(-50%) scale(.7);
  }
  .store-group {
    position: absolute;
    top: 8.1rem;
    left: 50%;
    transform: translateX(-50%);
    min-width: 4.8rem;
    a {
      float: left;
      display: inline-block;
      width: 2.25rem;
      height: .71rem;
    }
    .app-store {
      background: url("../assets/images/index-mb/page1/app-store.png") center top no-repeat;
      background-size: contain;
      margin-right: .30rem;
    }
    .google-play {
      background: url("../assets/images/index-mb/page1/google-play.png") center top no-repeat;
      background-size: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/index/page1.vue